<template>
    <div
        :class="classes"
        ref="thumb"
        :style="`left:calc(${boundValue * 100}% - 8px)`"
        @touchstart="mouseDown"
        @mousedown="mouseDown"
    >
        <div class="halo" ref="halo" />
    </div>
</template>
<script>
function addOnceEventListener(el, eventName, cb, options) {
    if (!cb) {
        return
    }

    var once = event => {
        cb(event)
        el.removeEventListener(eventName, once, options)
    }

    el.addEventListener(eventName, once, options)
}

export default {
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Number,
            default: 0,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            oldValue: this.modelValue,
            dragging: false,
        }
    },
    watch: {
        disabled() {
            if (this.disabled && this.dragging) {
                this.boundValue = this.oldValue
                this.dragging = false
            }
        },
    },
    computed: {
        classes() {
            return { 'slider-thumb': true, dragging: this.dragging }
        },
        boundValue: {
            get() {
                return parseFloat(this.modelValue)
            },
            set(val) {
                val = isNaN(val) ? 0 : val

                this.$emit('update:modelValue', val)
            },
        },
    },
    methods: {
        mouseDown(e) {
            if (this.disabled) {
                return
            }

            e.preventDefault()
            this.oldValue = this.boundValue
            this.keyPressed = 2
            this.dragging = true
            const mouseUpOptions = { passive: true, capture: true }
            const mouseMoveOptions = { passive: true }
            if ('touches' in e) {
                document.addEventListener('touchmove', this.mouseMove, mouseMoveOptions)
                addOnceEventListener(document, 'touchend', this.mouseUp, mouseUpOptions)
            } else {
                document.addEventListener('mousemove', this.mouseMove, mouseMoveOptions)
                addOnceEventListener(document, 'mouseup', this.mouseUp, mouseUpOptions)
            }
            this.$emit('start', this.boundValue)
        },
        mouseUp(e) {
            this.dragging = false
            this.keyPressed = 0
            const mouseMoveOptions = { passive: true }
            document.removeEventListener('touchmove', this.mouseMove, mouseMoveOptions)
            document.removeEventListener('mousemove', this.mouseMove, mouseMoveOptions)

            if (e) {
                e.stopPropagation()
                this.$emit('mouseup', e)
                this.$emit('end', this.boundValue)
                if (this.oldValue !== this.boundValue) {
                    this.$emit('change', this.boundValue)
                }
            }
        },
        mouseMove(e) {
            this.boundValue = this.parseMouseMove(e)
        },
        parseMouseMove(e) {
            const { left, width } = this.$el.parentElement.getBoundingClientRect()
            const clickOffset = 'touches' in e ? e.touches[0].clientX : e.clientX
            return (clickOffset - left) / width || 0
        },
    },
}
</script>
<style scoped>
@import './slider.css';

.slider-thumb {
    background-color: var(--color-secondary-500);
    border-radius: calc(var(--thumb-size) / 2);
    position: absolute;
    height: var(--thumb-size);
    top: calc(var(--thumb-size) / -2);
    width: var(--thumb-size);

    .halo {
        background-color: transparent;
        border-radius: calc(var(--control-height / 2));
        border-style: none !important;
        height: var(--control-height);
        left: calc((var(--thumb-size) - var(--control-height)) / 2);
        position: absolute;
        top: calc((var(--thumb-size) - var(--control-height)) / 2);
        width: var(--ccontrol-height);
        z-index: -1;
    }

    &.dragging .halo {
        background-color: var(--color-secondary-050) !important;
        opacity: 50%;
    }
}
</style>
